package br.com.texeratx.boardgametimeapp.ui.screens.players

import br.com.texeratx.boardgametimeapp.ui.screens.players.model.PlayerListItemUI

data class PlayersUiState(
    val players: List<PlayerListItemUI> = emptyList(),
    val isLoading: Boolean = false,
    val error: String? = null,
    val searchQuery: String = "",
    val filters: PlayersFilter = PlayersFilter(),
    val sort: PlayerSortOption = PlayerSortOption.NAME_ASC
)
